module.exports = __webpack_public_path__ + "img/capa-site 01.664fe369.jpg";